<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">storefront</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">{{ cliente?.nome || 'Cliente' }}</h2>
    @if (linhaResumo) {
      <p class="modal-subtitle">{{ linhaResumo }}</p>
    }
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar"
      (click)="fechar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <!-- Sem estado de carregamento: o modal abre com o cliente que o card ja tinha em maos. -->
  @if (cliente) {

    <!-- O aviso fica ACIMA das abas: saber se o cliente pode ser usado neste documento é a
         primeira pergunta de quem abre o modal, e não um detalhe de uma das abas. -->
    @if (avisoAtraso) {
      <app-alert-card [type]="avisoAtraso.tipo" [title]="avisoAtraso.titulo" [closable]="true">
        {{ avisoAtraso.texto }}
      </app-alert-card>
    }

    <mat-tab-group class="cliente-tabs" appTabsScroll [mat-stretch-tabs]="false"
      [disablePagination]="true" [selectedIndex]="abaInicial">

      <!-- ================= Dados ================= -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="material-symbols-outlined tab-icon">badge</mat-icon>
          <span class="tab-label-text">Dados do cliente</span>
        </ng-template>

        <div class="aba-conteudo grade-dados">
          @for (campo of dados; track campo.label) {
            <div>
              <div class="campo-label">{{ campo.label }}</div>
              <div class="campo-valor">
                @switch (campo.formato) {
                  @case ('documento') { {{ campo.valor | cpfCnpj }} }
                  @case ('telefone') { {{ campo.valor | foneMask }} }
                  @case ('data') { {{ campo.valor | date: 'dd/MM/yyyy' }} }
                  @default { {{ campo.valor }} }
                }
              </div>
            </div>
          }
        </div>
      </mat-tab>

      <!-- ================= Últimas vendas ================= -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="material-symbols-outlined tab-icon">receipt_long</mat-icon>
          <span class="tab-label-text">Últimas vendas</span>
        </ng-template>

        <div class="aba-conteudo">
          @if (historico && historico.vendas.length) {
            <div class="kpis">
              <div>
                <div class="campo-label">Total comprado</div>
                <div class="kpi-valor">{{ historico.totalComprado | abnt: 'preco' : 2 }}</div>
              </div>
              <div>
                <div class="campo-label">Ticket médio</div>
                <div class="kpi-valor">{{ historico.ticketMedio | abnt: 'preco' : 2 }}</div>
              </div>
            </div>

            <div class="table-container desktop-view">
              <table mat-table [dataSource]="historico.vendas" class="w-100">
                <ng-container matColumnDef="documento">
                  <th mat-header-cell *matHeaderCellDef>Documento</th>
                  <td mat-cell *matCellDef="let venda" class="fw-semibold">{{ rotuloDocumento(venda) }}</td>
                </ng-container>

                <ng-container matColumnDef="dataVendedor">
                  <th mat-header-cell *matHeaderCellDef>Data / vendedor</th>
                  <td mat-cell *matCellDef="let venda">{{ venda.dataEmissao | date: 'dd/MM/yyyy' }} · {{ venda.nomeVendedor || 'Sem vendedor' }}</td>
                </ng-container>

                <ng-container matColumnDef="valor">
                  <th mat-header-cell *matHeaderCellDef class="text-end">Valor</th>
                  <td mat-cell *matCellDef="let venda" class="text-end">{{ venda.valorTotal | abnt: 'preco' : 2 }}</td>
                </ng-container>

                <ng-container matColumnDef="etapa">
                  <th mat-header-cell *matHeaderCellDef>Etapa</th>
                  <td mat-cell *matCellDef="let venda">
                    <span class="status-badge" [style.background]="corDaEtapa(venda).fundo"
                      [style.color]="corDaEtapa(venda).conteudo">
                      {{ venda.nomeEtapaKanban || 'Sem etapa' }}
                    </span>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="colunasVendas"></tr>
                <tr mat-row *matRowDef="let venda; columns: colunasVendas;"></tr>
              </table>
            </div>

            <div class="mobile-view">
              @for (venda of historico.vendas; track venda.idVenda) {
                <div class="card-mobile mb-3">
                  <div class="card-header-mobile">
                    <span class="fw-semibold">{{ rotuloDocumento(venda) }}</span>
                  </div>
                  <div class="card-body-mobile p-3">
                    <p class="mb-2">
                      <strong>Data / vendedor:</strong>
                      {{ venda.dataEmissao | date: 'dd/MM/yyyy' }} · {{ venda.nomeVendedor || 'Sem vendedor' }}
                    </p>
                    <p class="mb-2">
                      <strong>Valor:</strong>
                      {{ venda.valorTotal | abnt: 'preco' : 2 }}
                    </p>
                    <p class="mb-0">
                      <strong>Etapa:</strong>
                      <span class="status-badge ms-1" [style.background]="corDaEtapa(venda).fundo"
                        [style.color]="corDaEtapa(venda).conteudo">
                        {{ venda.nomeEtapaKanban || 'Sem etapa' }}
                      </span>
                    </p>
                  </div>
                </div>
              }
            </div>

            <p class="nota">
              As {{ historico.vendas.length }} últimas vendas deste cliente. O total comprado e o
              ticket médio são destas vendas, não de todo o histórico.
            </p>
          } @else {
            <div class="estado-central">
              <mat-icon class="material-symbols-outlined icone-grande">receipt_long</mat-icon>
              <p>Este cliente ainda não tem vendas registradas.</p>
            </div>
          }
        </div>
      </mat-tab>

      <!-- ================= Limite de crédito ================= -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="material-symbols-outlined tab-icon">credit_score</mat-icon>
          <span class="tab-label-text">Limite de crédito</span>
        </ng-template>

        <div class="aba-conteudo">
          <div class="grade-credito">
            <div class="cartao">
              <mat-icon class="material-symbols-outlined icone-limite">account_balance_wallet</mat-icon>
              <span class="cartao-valor">
                @if (cliente.limiteCredito != null) {
                  {{ cliente.limiteCredito | abnt: 'preco' : 2 }}
                } @else {
                  &mdash;
                }
              </span>
              <span class="cartao-label">Limite total</span>
            </div>

            <div class="cartao">
              <mat-icon class="material-symbols-outlined icone-usado">shopping_cart</mat-icon>
              <span class="cartao-valor">{{ cliente.valorEmAberto | abnt: 'preco' : 2 }}</span>
              <span class="cartao-label">Utilizado</span>
            </div>

            <!-- Em aberto acima do limite: o número negativo não é "disponível", é o quanto excedeu. -->
            @if (cliente.limiteDisponivel != null && cliente.limiteDisponivel < 0) {
              <div class="cartao">
                <mat-icon class="material-symbols-outlined icone-usado">error</mat-icon>
                <span class="cartao-valor">{{ -cliente.limiteDisponivel | abnt: 'preco' : 2 }}</span>
                <span class="cartao-label">Excedido</span>
              </div>
            } @else {
              <div class="cartao">
                <mat-icon class="material-symbols-outlined icone-disponivel">check_circle</mat-icon>
                <span class="cartao-valor">
                  @if (cliente.limiteDisponivel != null) {
                    {{ cliente.limiteDisponivel | abnt: 'preco' : 2 }}
                  } @else {
                    &mdash;
                  }
                </span>
                <span class="cartao-label">Disponível</span>
              </div>
            }
          </div>

          @if (percentualUsado != null) {
            <div class="barra-cabecalho">
              <span class="barra-titulo">Utilização do limite</span>
              <span class="barra-pct" [class]="'pct-' + situacaoDoLimite.classe">{{ percentualUsado }}%</span>
            </div>

            <div class="barra-fundo">
              <div class="barra" [class]="'barra-' + situacaoDoLimite.classe" [style.width.%]="percentualUsado"></div>
            </div>
          }

          <div class="situacao">
            <span [class]="'status-badge ' + situacaoDoLimite.badge">
              <mat-icon class="material-symbols-outlined">{{ situacaoDoLimite.icon }}</mat-icon>
              {{ situacaoDoLimite.label }}
            </span>
          </div>

          <p class="nota">
            O disponível é o limite do cadastro do cliente menos os títulos que ele ainda deve.
          </p>
        </div>
      </mat-tab>

      <!-- ================= Pessoas de contato ================= -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="material-symbols-outlined tab-icon">contacts</mat-icon>
          <span class="tab-label-text">Pessoas de contato</span>
        </ng-template>

        <div class="aba-conteudo">
          @if (cliente.contatos.length) {
            <div class="lista-contatos">
              @for (contato of cliente.contatos; track contato.idPessoaContato) {
                <div class="contato">
                  <span class="avatar">{{ contato.nome.charAt(0).toUpperCase() }}</span>

                  <div class="contato-corpo">
                    <div class="contato-nome">{{ contato.nome }}</div>
                    @if (contato.cargo) {
                      <div class="contato-cargo">{{ contato.cargo }}</div>
                    }
                    <div class="contato-meta">
                      @if (contato.telefone) {
                        <span><mat-icon class="material-symbols-outlined">call</mat-icon>{{ contato.telefone | foneMask }}</span>
                      }
                      @if (contato.email) {
                        <span><mat-icon class="material-symbols-outlined">mail</mat-icon>{{ contato.email }}</span>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="estado-central">
              <mat-icon class="material-symbols-outlined icone-grande">contacts</mat-icon>
              <p>Nenhuma pessoa de contato cadastrada para este cliente.</p>
            </div>
          }
        </div>
      </mat-tab>
    </mat-tab-group>
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button class="btn-secondary" (click)="fechar()">Fechar</button>
</mat-dialog-actions>
